import React, {
    useMemo, useContext, useCallback, useState
} from 'react';
import { TranslatorContext } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/layout';
import htmlParser from 'html-react-parser';
import { SgProductService } from 'saga-modules';
import SpmConstants from 'sg-spm-constants';
import CommonConstants from 'sg-common-constants';
import {
    Accordion, AccordionCard, Button, Link
} from '@jutro/components';
import StringUtil from 'gw-portals-util-js/StringUtil';
import messages from './SgSpmError.messages';

function SgSpmError(props) {
    const {
        errorCodeT,
        errorCodeC
    } = props;

    const {
        SG_ERROR_CODES,
        SG_ERROR_REASONS,
        SAGA_PHONE_NUMBERS,
        SAGA_HOME
    } = CommonConstants;
    const vehicleType = SgProductService.isMotorHome() ? SpmConstants.MOTORHOME : SpmConstants.CAR;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const isMobile = breakpoint === 'tablet' || breakpoint === 'phoneWide' || breakpoint === 'phone';

    const [openedAccordionId, setOpenedAccordionId] = useState('nonPurchasableAccordion0');

    const onAccordionStateChange = (openedAccordionsIds) => {
        setOpenedAccordionId(openedAccordionsIds[0]);
    };

    const phoneNumber = useMemo(() => { // for T9
        switch (openedAccordionId) {
            case 'nonPurchasableAccordion0': return SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_RENEWAL;
            case 'nonPurchasableAccordion1': return SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_CHANGE;
            case 'nonPurchasableAccordion2': return SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER;
            default: return SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER;
        }
    }, [openedAccordionId]);

    const renderExistingCustomerErrorContent = useCallback(() => {
        return (
            <>
                <Accordion
                    closeOthers
                    disabled={false}
                    id="FaqAccordion"
                    showFrame={false}
                    defaultOpenedId="nonPurchasableAccordion0"
                    onUpdateAccordionStates={onAccordionStateChange}
                    className="sgErrorPageAccordion"
                >
                    <AccordionCard
                        id="nonPurchasableAccordion0"
                        isCollapsible
                        title={translator(messages.ExistingCustomerAnswer1)}
                        className="sgErrorPageAccordionCard"
                    >
                        <p className="sgErrorPagePrimaryText">
                            {htmlParser(translator(messages.ExistingCustomerAnswer1Content0))}
                            <strong>
                                {translator(messages.ExistingCustomerAnswer1Content1, {
                                    phoneNumber: isMobile
                                        ? (
                                            <a
                                                // eslint-disable-next-line max-len
                                                href={`tel:${SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_RENEWAL.replaceAll(' ', '')}`}
                                            >
                                                {SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_RENEWAL}
                                            </a>
                                        ) : SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_RENEWAL
                                })}
                            </strong>
                        </p>
                        <p className="sgErrorPageSecondaryText">{htmlParser(translator(messages.ExistingCustomerAnswer1Content2))}</p>
                    </AccordionCard>
                    <AccordionCard
                        id="nonPurchasableAccordion1"
                        isCollapsible
                        title={translator(messages.ExistingCustomerAnswer2)}
                        className="sgErrorPageAccordionCard"
                    >
                        <p className="sgErrorPagePrimaryText">
                            {translator(messages.ExistingCustomerAnswer2Content0)}
                            <Link
                                target="_blank"
                                rel="noreferrer"
                                href="https://www.saga.co.uk/insurance/car-insurance/existing-customers.aspx"
                            >
                                {translator(messages.Here)}
                            </Link>
                            .
                        </p>
                        <p className="sgErrorPageSecondaryText">
                            {translator(messages.ExistingCustomerAnswer2Content1)}
                            <strong>
                                {translator(messages.ExistingCustomerAnswer2Content2, {
                                    phoneNumber: isMobile
                                        ? (
                                            <a
                                                // eslint-disable-next-line max-len
                                                href={`tel:${SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_CHANGE.replaceAll(' ', '')}`}
                                            >
                                                {SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_CHANGE}
                                            </a>
                                        ) : SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER_FOR_DUP_POLICY_CHANGE
                                })}
                            </strong>
                            {translator(messages.ExistingCustomerAnswer2Content3)}
                        </p>
                    </AccordionCard>
                    <AccordionCard
                        id="nonPurchasableAccordion2"
                        isCollapsible
                        title={translator(messages.ExistingCustomerAnswer3)}
                        className="sgErrorPageAccordionCard"
                    >
                        <p className="sgErrorPagePrimaryText">{translator(messages.ExistingCustomerAnswer3Content0)}</p>
                        <p className="sgErrorPageSecondaryText">
                            {translator(messages.ExistingCustomerAnswer3Content1)}
                            <strong>
                                {translator(messages.ExistingCustomerAnswer3Content2, {
                                    phoneNumber: isMobile
                                        ? (
                                            <a
                                                href={`tel:${SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER.replaceAll(' ', '')}`}
                                            >
                                                {SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER}
                                            </a>
                                        ) : SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER
                                })}
                            </strong>
                            {translator(messages.ExistingCustomerAnswer3Content3)}
                        </p>
                    </AccordionCard>
                </Accordion>
                <div>
                    <p className="sgErrorPagePhoneNumber">
                        {translator(messages.CallUsOn, {
                            number: isMobile
                                ? <a className="sgErrorPagePhoneNumber" href={`tel:${phoneNumber.replaceAll(' ', '')}`}>{phoneNumber}</a>
                                : phoneNumber
                        })}
                    </p>
                    <Link href={SAGA_HOME}>
                        <Button
                            className="sgButton sgPrimaryButton"
                            id="returnToHomepageButton"
                        >
                            {translator(messages.SagaHomepage)}
                        </Button>
                    </Link>
                </div>
            </>
        );
    }, [errorCodeT, phoneNumber, translator, isMobile]);

    const headerContent = useMemo(() => {
        switch (errorCodeT) {
            case SG_ERROR_CODES.SAGA_DECLINE: // decline
            case SG_ERROR_CODES.SAGA_REFERRAL: // referral
            case SG_ERROR_CODES.SAGA_POLARIS_REFERRAL: // T12
                return htmlParser(translator(messages.ErrorHeader, { vehicleType: `<span>${StringUtil.capitalizeFirstLetter(vehicleType)}</span>` }));
            case SG_ERROR_CODES.SAGA_NON_PURCHASABLE_QUOTE:
                return translator(messages.ExistingCustomerHeader);
            default:
                return '';
        }
    }, [errorCodeT, vehicleType]);

    const getDeclineMessageContent = useCallback(() => {
        switch (errorCodeC) {
            case SG_ERROR_REASONS.ABILITY_TO_PAY_ERROR: // T0 C9199
                return (
                    <>
                        <p id="message_motor" className="sgErrorPagePrimaryText">
                            {translator(messages.DeclineErrorMessageAbilityToPay,
                                { phoneNumber: SAGA_PHONE_NUMBERS.SAGA_HELP_DESK_MOTOR_PHONE_NUMBER2 })}
                        </p>
                        <Link href={SAGA_HOME} className="sgErrorPageNewQuoteLink">
                            {translator(messages.ReturnToSagaHomepage)}
                        </Link>
                    </>
                );
            default:
                return (
                    <>
                        <p id="message_motor" className="sgErrorPagePrimaryText">{translator(messages.DeclineErrorMessage)}</p>
                    </>
                );
        }
    }, [errorCodeC, translator, isMobile]);

    const messageContent = useMemo(() => {
        switch (errorCodeT) {
            case SG_ERROR_CODES.SAGA_DECLINE: // T0
            case SG_ERROR_CODES.SAGA_POLARIS_REFERRAL: // T12
                return getDeclineMessageContent();
            case SG_ERROR_CODES.SAGA_REFERRAL: // T1
                return (
                    <>
                        <p id="message_motor" className="sgErrorPagePrimaryText">{translator(messages.ReferralMessage1)}</p>
                        <p className="sgErrorPageSecondaryText">{translator(messages.ReferralMessage2)}</p>
                        {isMobile
                            ? (
                                <a
                                    className="sgErrorPagePhoneNumber"
                                    href={`tel:${SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER.replaceAll(' ', '')}`}
                                >
                                    {SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER}
                                </a>
                            ) : (
                                <p className="sgErrorPagePhoneNumber">{SAGA_PHONE_NUMBERS.SAGA_MOTOR_ERROR_PAGE_PHONE_NUMBER}</p>
                            )}
                        <p className="sgErrorPageLinesOpen">{translator(messages.LinesOpen)}</p>
                    </>
                );
            case SG_ERROR_CODES.SAGA_NON_PURCHASABLE_QUOTE: // T9
                return renderExistingCustomerErrorContent();
            default:
                return '';
        }
    }, [errorCodeT, phoneNumber, isMobile]);

    return (
        <div>
            <h1>{headerContent}</h1>
            <div>{messageContent}</div>
        </div>
    );
}

export default SgSpmError;
